/* Copyright (C) 2020 Carlo Capuano - All Rights Reserved
 * You may use, distribute and modify this code under the
 * terms of the MIT license.
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GuidService {
  public ids = new Set<string>();

  constructor() {}

  public generate(): string {
    let isUnique = false;
    let tempId = '';

    while (!isUnique) {
      tempId = this.generator();
      if (!this.idExists(tempId)) {
        isUnique = true;
        this.ids.add(tempId);
      }
    }

    return tempId;
  }

  private generator(): string {
    const isString = `${this.S4()}${this.S4()}-${this.S4()}-${this.S4()}-${this.S4()}-${this.S4()}${this.S4()}${this.S4()}`;

    return isString;
  }

  private idExists(id: string): boolean {
    return this.ids.has(id);
  }

  private S4(): string {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
}
